module.exports = "../../../../platform/assets/pageMainIcon/industry_jichudanganlei1.svg";